var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"text-center d-inline-block",attrs:{"width":"20","height":"20","color":"#E2252F","dark":"","tile":""}},[_vm._v(_vm._s(_vm.ranking))])}
var staticRenderFns = []

export { render, staticRenderFns }